import React, { useEffect, useMemo } from "react";
import { gql, useQuery } from "@apollo/client";
import { HeroSection } from "../LandingPage/HeroSection";
import { LIST_BANNER } from "apollo/queries/banner";
import { pickBannerRowForSlot } from "utils";
import FeaturesSection from "./FeaturesSection";
import HowItWorksSection from "./HowItWorksSection";
import CTASection from "./CTASection";

const HERO_DATA = {
  image: "/images/hero-background.png",
  badge: "Fit Starts With The Tree",
  titleAccent: "Custom Saddle Tree",
  subtitle: "Your Maker & Your Saddle",
  description:
    "When the tree is off, everything else works too hard. Start with a 3D scan so your tree matches your horse's back—then pass it to the saddle maker you already trust. We're not replacing your craftsman; we're helping you get the foundation right before the leather ships.",
  primaryBtn: "Find your fit",
  primaryBtnUrl: "/buy",
  secondaryBtn: "How it works",
  secondaryBtnUrl: "#how-it-works",
};

function cssBackgroundValue(imageUrl) {
  const u = imageUrl || "/images/hero-background.png";
  if (u.startsWith("http://") || u.startsWith("https://")) {
    return `url("${u.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}")`;
  }
  return `url(${u})`;
}

export default function CustomSaddleTreePage() {
  const { data } = useQuery(gql(LIST_BANNER), {
    variables: { filter: { type: "CUSTOM_SADDLE_TREE" } },
    fetchPolicy: "cache-and-network",
  });
  const banner = useMemo(
    () => pickBannerRowForSlot(data?.listBanner, 0),
    [data?.listBanner],
  );
  const cmsImage = banner?.image;

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--custom-saddle-hero-bg",
      cssBackgroundValue(cmsImage),
    );
    document.documentElement.style.setProperty(
      "--custom-saddle-hero-bg-size",
      banner?.imageBackgroundSize || "cover",
    );
    document.documentElement.style.setProperty(
      "--custom-saddle-hero-bg-position",
      banner?.imageBackgroundPosition || "center center",
    );
    return () => {
      document.documentElement.style.removeProperty("--custom-saddle-hero-bg");
      document.documentElement.style.removeProperty("--custom-saddle-hero-bg-size");
      document.documentElement.style.removeProperty("--custom-saddle-hero-bg-position");
    };
  }, [cmsImage, banner?.imageBackgroundSize, banner?.imageBackgroundPosition]);

  return (
    <div className="w-full">
      <HeroSection isCustomSaddle heroData={HERO_DATA} />
      <FeaturesSection />
      <HowItWorksSection />
      <CTASection />
    </div>
  );
}
